import { useT } from '../../i18n';
import styles from './FormSubmissionBubble.module.css';

export function FormSubmissionBubble() {
  const t = useT();

  return (
    <div className={styles.container}>
      <div className={styles.bubble}>
        <span className={styles.iconWrapper}>
          <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.3 4.7a1 1 0 0 1 0 1.4l-5.6 5.6a1 1 0 0 1-1.4 0L3.7 9.1a1 1 0 1 1 1.4-1.4L6.7 9.3l4.9-4.9a1 1 0 0 1 1.4 0Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className={styles.label}>{t('form.submitted')}</span>
      </div>
    </div>
  );
}
